export default __webpack_public_path__ + "static/media/10.2574f641.jpeg";